import { CustomerService } from "./customer.service";
import { CartService } from "./cart.service";
import { OrderService } from "./order.service";
import { ProductService } from "./product.service";
import { GtagService } from "./gtag.service";
import { PromotionService } from "./promotion.service";
export class ELLCommerce {
    constructor() {
        this.cartService = null;
        this.customerService = null;
        this.orderService = null;
        this.productService = null;
        this.promotionService = null;
    }
    static getInstance(config) {
        if (ELLCommerce.classInstance === null) {
            ELLCommerce.classInstance = new ELLCommerce();
            ELLCommerce.classInstance.config = config;
        }
        return this.classInstance;
    }
    CartService() {
        if (this.cartService === null) {
            this.cartService = new CartService(ELLCommerce.classInstance);
        }
        return this.cartService;
    }
    CustomerService() {
        if (this.customerService === null) {
            this.customerService = new CustomerService(ELLCommerce.classInstance);
        }
        return this.customerService;
    }
    OrderService() {
        if (this.orderService === null) {
            this.orderService = new OrderService(ELLCommerce.classInstance);
        }
        return this.orderService;
    }
    ProductService() {
        if (this.productService === null) {
            this.productService = new ProductService(ELLCommerce.classInstance);
        }
        return this.productService;
    }
    PromotionService() {
        if (this.promotionService === null) {
            this.promotionService = new PromotionService(ELLCommerce.classInstance);
        }
        return this.promotionService;
    }
    static get GTagService() {
        var _a, _b;
        if (this.gtagService === null) {
            this.gtagService = new GtagService((_b = (_a = ELLCommerce.classInstance) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.applicationId);
        }
        return this.gtagService;
    }
}
ELLCommerce.classInstance = null;
ELLCommerce.gtagService = null;
